
import { h, Fragment } from 'preact'; /** @jsx h */
//import { lazy } from 'preact-iso';

import { Page, Course, ICategory } from '@pyqml/model';
import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

import { useAuth } from "../app/AuthProvider";
import { useEnvironment } from "../app/Environment";
import { useCacheableQueryProvider } from "../app/CacheableQueryProvider";

import { Layout } from '../components/Layout';
import { List } from '../components/List';
import { Subheader } from '../components/Subheader';

import { SubscribeSection } from '../glue/SubscribeSection';
import { Subscribe } from "../components/Subscribe";

import { PyQMLTeaser } from '../components/PyQMLTeaser';
import { BlogCover } from '../components/BlogCover';


export const Home = (props) => {
    
    const { subdomain, baseUrl, imageUrl } = useEnvironment();
    const { subscriptionLevel } = useAuth();

    const { cacheableQuery } = useCacheableQueryProvider();
    
    // fetch the "teaser" modules
    const [pyqml, refetch, count] = cacheableQuery?.({
        method: "POST",
        endpoint: ROUTES.CLOUDAPI_PUBLIC_GET_PYQML_HOME,
        queryData: {},
        reloadOn: []
    });

    const { pyqmlWiki, teaserCourses, pyqmlCourses } = pyqml?.data ?? { pyqmlWiki: undefined, teaserCourses: undefined, pyqmlCourses: undefined };

    //console.log("Home", pyqml, pyqmlWiki, teaserCourses, pyqmlCourses)

    return <Layout.Stacked>


        <Fragment as="Section">
            <BlogCover
                title="The Unprecedented Way To Learn Practical Quantum Machine Learning"
                subtitle="Get started with quantum machine learning easily" />
            <PyQMLTeaser pyqmlWiki={pyqmlWiki} teaserCourses={teaserCourses}/>
        </Fragment>
        

        <SubscribeSection as="Section"/>
        
        { !subscriptionLevel &&
            <Layout.Section weight="full">
                <hr />
                <Subscribe />
            </Layout.Section> || <Fragment></Fragment>
        }

        <Layout.Section weight="full">
            <hr />
            <h2 style={{marginBottom:"1.5em"}}>Available Modules</h2>
            <Subheader icon="fab fa-leanpub" iconColor="student" title="Student" tight  />
            
            <List.Standard>
            {
                    pyqmlCourses?.filter(
                        (course: Course.ICourse) => course.slug !== "unprecedented" && course.requiredLevel === "student"
                    ).map((course: Course.ICourse) => (
                        <List.Item
                            title={ course.title }
                            abstract={ course.abstract }
                            image={ course.abstractImage ? `/${subdomain}/${course.abstractImage}` : undefined}
                            linkTo={ `${ROUTES.BLOG_COURSE}/${course.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish(course.revision) }
                            readingTime={ course.readingTime ?? undefined }
                        />
                    ))
                }
                
            </List.Standard>

            <Subheader icon="fas fa-user-astronaut" iconColor="practitioner" title="Practitioner" tight />
            <List.Standard>
            {
                    pyqmlCourses?.filter(
                        (course: Course.ICourse) => course.slug !== "unprecedented" && course.requiredLevel === "practitioner"
                    ).map((course: Course.ICourse) => (
                        <List.Item
                            title={ course.title }
                            abstract={ course.abstract }
                            image={ course.abstractImage ? `/${subdomain}/${course.abstractImage}` : undefined}
                            linkTo={ `${ROUTES.BLOG_COURSE}/${course.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish(course.revision) }
                            readingTime={ course.readingTime ?? undefined }
                        />
                    ))
                }
                
            </List.Standard>

            <Subheader icon="fas fa-flask" iconColor="researcher" title="Researcher" tight />
            <List.Standard>
            {
                    pyqmlCourses?.filter(
                        (course: Course.ICourse) => course.slug !== "unprecedented" && course.requiredLevel === "researcher"
                    ).map((course: Course.ICourse) => (
                        <List.Item
                            title={ course.title }
                            abstract={ course.abstract }
                            image={ course.abstractImage ? `/${subdomain}/${course.abstractImage}` : undefined}
                            linkTo={ `${ROUTES.BLOG_COURSE}/${course.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish(course.revision) }
                            readingTime={ course.readingTime ?? undefined }
                        />
                    ))
                }
                
            </List.Standard>
            
        
        </Layout.Section>
        
    
    </Layout.Stacked>
            
}
  
